import type {
  HighlightReview,
  FilterableTaxon,
  PageType,
  Review
} from '@/types/models'
import type { PrimaryFocus } from '../primaryFocus/constant'
import { MINIMUM_REVIEWS } from './filterReviewsByTermOrPrimaryFocus'
import { filterTaxonomyForTerms } from './filterTaxonomyForTerms'
import { filterReviewsWithNoConditions } from './filterReviewsWithNoConditions'

export const filterReviewsForLocationPages = ({
  reviews,
  filterableTaxonomies,
  pageType,
  primaryFocus
}: {
  reviews: HighlightReview[]
  filterableTaxonomies: FilterableTaxon[]
  pageType: PageType
  primaryFocus: PrimaryFocus
}): Review[] => {
  const filterTerms: string[] = filterTaxonomyForTerms({
    filterableTaxonomies,
    primaryFocus,
    pageType
  })
  const locationReviews: HighlightReview[] = reviews.filter(
    (review: HighlightReview) =>
      review.conditions_treated.some((condition) =>
        filterTerms.includes(condition)
      )
  )
  if (checkLocationReviewsForUniqueCenters(locationReviews)) {
    return [...locationReviews, ...reviews]
  }
  return locationReviews
}

const checkLocationReviewsForUniqueCenters = (
  locationReviews: Review[]
): boolean => {
  const includedCenters = new Set<string>()
  const uniqueReviews = locationReviews.filter((review: HighlightReview) => {
    if (!review._center || !review._center.slug) return false
    if (includedCenters.size === MINIMUM_REVIEWS) return false
    if (!includedCenters.has(review._center.slug)) {
      includedCenters.add(review._center.slug)
      return true
    }
    return false
  })
  return uniqueReviews.length < MINIMUM_REVIEWS
}
